import { render } from "./PassThrough.vue?vue&type=template&id=26f356dc&scoped=true"
import script from "./PassThrough.vue?vue&type=script&lang=js"
export * from "./PassThrough.vue?vue&type=script&lang=js"

import "./PassThrough.vue?vue&type=style&index=0&id=26f356dc&scoped=true&lang=css"

import exportComponent from "/home/phamdat/project/pos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26f356dc"]])

export default __exports__